import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LoaderService, LoaderState } from '../../../Services/Common/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  isVisible = false;
  message: string | null = null;
  private sub: Subscription | null = null;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.sub = this.loaderService.loader$.subscribe((s: LoaderState) => {
      this.isVisible = !!s?.visible;
      this.message = s?.message || null;
    });
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }
}
